export const handleLicenseTypeChange = (
  event,
  index,
  values,
  setFieldValue
) => {
  const selectedValue = event.target.value;
  const newLicenses = values.licenses.map((lic, idx) =>
    idx === index ? { ...lic, licenseType: selectedValue } : lic
  );
  setFieldValue('licenses', newLicenses);
};
